<template>
  <div class="seek_detail_page">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ $t("part.viewDetail") }}
      </div>
      <p class="status">
        {{ $t("seek.orderStatus") }}：{{ getStatus(seekInfo.status) }}
      </p>
    </div>
    <div class="form_info">
      <el-form :inline="true" :model="seekInfo">
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.workBasic") }}
          </div>
        </div>
        <div class="form-container">
          <el-form-item :label="$t('seek.theme')" required>
            <el-input disabled v-model="seekInfo.consultSubject"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.happenDate')" required>
            <el-date-picker
              disabled
              value-format="yyyy-MM-dd"
              type="date"
              placeholder=""
              v-model="seekInfo.happenDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('seek.warrantyDate')" required>
            <el-date-picker
              disabled
              value-format="yyyy-MM-dd"
              type="date"
              placeholder=""
              v-model="seekInfo.repairsDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('seek.quantity')">
            <el-input
              disabled
             
              type="text"
              v-model="seekInfo.carCount"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.HappenPlace')" required>
            <el-input disabled v-model="seekInfo.happenPlace"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.attribute')" required>
            <el-radio-group
              disabled
              v-model="seekInfo.carAttributes"
              class="radio-group"
            >
              <el-radio :label="1">{{ $t("seek.commercial") }} </el-radio>
              <el-radio :label="2">{{ $t("seek.domestic") }} </el-radio>
              <el-radio :label="3">{{ $t("seek.nonDomestic") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('seek.distance')" required>
            <el-input
              disabled
           
              type="number"
              v-model="seekInfo.roadHaul"
            >
              <template slot="append">km</template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.culpritName')" required>
            <el-input
              disabled
              v-model="seekInfo.suspectedCulpritName"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.culpritCode')">
            <el-input
              disabled
              v-model="seekInfo.suspectedCulpritCode"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.supplier')">
            <el-input
              disabled
              v-model="seekInfo.suspectedCulpritSupplierCode"
            ></el-input>
          </el-form-item>
        </div>

        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.basic") }}
          </div>
        </div>
        <div class="form-container">
          <el-form-item label="VIN:" required>
            <!--  -->
            <el-input disabled v-model="seekInfo.vin"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.color')" required>
            <el-input disabled v-model="seekInfo.carColor"></el-input>
          </el-form-item>
          <el-form-item :label="$t('home.brand')" required>
            <el-input disabled v-model="seekInfo.carBrand"></el-input>
          </el-form-item>
          <el-form-item :label="$t('home.carType')" required>
            <el-input disabled v-model="seekInfo.carModel"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.produceDate')" required>
            <!-- <el-input v-model=" seekInfo.productionDate"></el-input> -->
            <el-date-picker
              disabled
              value-format="yyyy-MM-dd"
              type="date"
              placeholder=""
              v-model="seekInfo.productionDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('seek.buyDate')" required>
            <!-- <el-input v-model=" seekInfo.salesDate"></el-input> -->
            <el-date-picker
              disabled
              value-format="yyyy-MM-dd"
              type="date"
              placeholder=""
              v-model="seekInfo.salesDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('seek.onlyEngine')" required>
            <el-input disabled v-model="seekInfo.engineModel"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.engineNUmber')" required>
            <el-input disabled v-model="seekInfo.engineNumber"></el-input>
          </el-form-item>
        </div>
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.maintenanceInfo") }}
          </div>
        </div>
        <div class="lookall" @click="showAll = true" v-show="!showAll">
          <p>{{ $t("seek.showAll") }}</p>
          <i class="el-icon-arrow-down"></i>
        </div>
        <div v-show="showAll">
          <div class="form-container">
            <div v-for="(item, index) in seekInfo.intervalList" :key="index">
              <el-form-item :label="$t(`seek.insuranceDate${index + 1}`)">
                <el-date-picker
                  disabled
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder=""
                  v-model="seekInfo.intervalList[index].insuranceDate"
                  style="width: 250px"
                ></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t(`seek.insuranceMileage${index + 1}`)">
                <el-input
                  disabled
                  type="number"
                  v-model="seekInfo.intervalList[index].insuranceMileage"
                >
                  <template slot="append">km</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t(`seek.insuranceProject${index + 1}`)">
                <el-input
                  disabled
                  v-model="seekInfo.intervalList[index].insuranceProject"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="hearder-title">
            <div class="flex_between">
              <img
                class="title-icon"
                src="@/assets/img/title-icon.svg"
                alt="dark"
              />
              {{ $t("seek.hitchDeac") }}
            </div>
          </div>
          <div class="form-container">
            <div>
              <el-form-item :label="$t('seek.drivingConditions')">
                <mycheck
                  :name="$t('seek.moderate')"
                  :checked="seekInfo.speedDown"
                />
                <mycheck
                  :name="$t('seek.retardation')"
                  :checked="seekInfo.braking"
                />
                <mycheck :name="$t('seek.turn')" :checked="seekInfo.steer" />
              </el-form-item>
              <el-form-item :label="$t('seek.position')">
                <el-input disabled type="text" v-model="seekInfo.gearValue">
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('seek.speed')">
                <el-input
                  disabled
                  type="text"
                  v-model="seekInfo.drivingSpeedValue"
                >
                  <template slot="append">km/h</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('seek.engineSpeed')">
                <el-input
                  disabled
                  type="text"
                  v-model="seekInfo.engineSpeedValue"
                >
                  <template slot="append">r/min</template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item :label="$t('seek.roadType')">
                <mycheck
                  :name="$t('seek.cement')"
                  :checked="seekInfo.concreteRoad"
                />
                <mycheck
                  :name="$t('seek.asphalt')"
                  :checked="seekInfo.asphaltRoad"
                />
                <mycheck
                  :name="$t('seek.unpaved')"
                  :checked="seekInfo.dirtRoad"
                />
                <mycheck
                  :name="$t('seek.gravel')"
                  :checked="seekInfo.gravelRoad"
                />
                <mycheck
                  :name="$t('seek.cinder')"
                  :checked="seekInfo.coalSlagRoad"
                />
              </el-form-item>
            </div>
            <div>
              <el-form-item :label="$t('seek.roadCondition')">
                <mycheck
                  :name="$t('seek.unsmooth')"
                  :checked="seekInfo.uneven"
                />
                <mycheck :name="$t('seek.even')" :checked="seekInfo.flat" />
                <mycheck
                  :name="$t('seek.upslope')"
                  :checked="seekInfo.uphill"
                />
                <mycheck
                  :name="$t('seek.downhill')"
                  :checked="seekInfo.downhill"
                />
              </el-form-item>
            </div>
            <div>
              <el-form-item :label="$t('seek.road')">
                <mycheck
                  :name="$t('seek.ponding')"
                  :checked="seekInfo.standingWater"
                />
                <mycheck :name="$t('seek.freeze')" :checked="seekInfo.freeze" />
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <mycheck
                    :name="$t('seek.other')"
                    :checked="seekInfo.roadConditionsOther"
                  />
                </el-form-item>
                <el-form-item>
                  <el-input
                    disabled
                    type="text"
                    v-model="seekInfo.roadConditionsOtherValue"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </div>
            <div>
              <el-form-item :label="$t('seek.weather')">
                <mycheck :name="$t('seek.sun')" :checked="seekInfo.clearDay" />
                <mycheck :name="$t('seek.rain')" :checked="seekInfo.rain" />
                <mycheck
                  :name="$t('seek.snow')"
                  :checked="seekInfo.heavySnow"
                />
                <mycheck
                  :name="$t('seek.wind')"
                  :checked="seekInfo.strongWind"
                />
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <mycheck
                    :name="$t('seek.other')"
                    :checked="seekInfo.weatherConditionsOther"
                  />
                </el-form-item>
                <el-form-item>
                  <el-input
                    disabled
                    type="text"
                    v-model="seekInfo.weatherConditionsOtherValue"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </div>
            <div>
              <el-form-item :label="$t('seek.PassengerCapacity')">
                <el-input disabled v-model="seekInfo.passengerCapacity">
                  <template slot="append">{{ $t("seek.person") }}</template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item :label="$t('seek.PassengerWeight')">
                <el-input disabled v-model="seekInfo.cargoWeight">
                  <template slot="append">kg</template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item :label="$t('seek.moreDesc')">
                <el-input
                  disabled
                  style="width: 680px"
                  type="textarea"
                  v-model="seekInfo.moreDescription"
                ></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item :label="$t('seek.appendix')">
                <div class="file">
                  <div
                    class="file-list"
                    style="cursor: pointer"
                    v-for="(data, idx) in seekInfo.fileList"
                    :key="idx"
                  >
                    <div class="left">
                      <i class="el-icon-document"></i
                      ><span>{{ data.fileName }}</span>
                    </div>
                    <div class="down-icon" v-if="data.downStatus">
                      {{ $t("operate.alreadyDown") }}
                    </div>
                    <div class="right" @click="downLoad(data.filePath, idx)">
                      {{ $t("home.down") }}
                    </div>
                    <div
                      class="right"
                      style="margin-left: 10px"
                      v-if="showViewBtn(data.fileType)"
                      @click="viewFile(data)"
                    >
                      {{ $t("operate.preview") }}
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="hearder-title" v-show="seekInfo.status != 3">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.leave") }}
          </div>
        </div>
        <div
          class="word"
          v-if="!isRecord && seekInfo.status != 2 && seekInfo.status != 3"
        >
          <div class="no-records">
            <el-input
              type="textarea"
              :maxlength="2950"
              v-model="replyContent"
            ></el-input>
            <div class="btn flex" style="align-items: flex-start">
              <el-upload
                class="upload-demo"
                ref="uploadFile"
                :action="action"
                :headers="header"
                multiple
                :on-success="handleFileSuccess"
                :before-upload="beforeFileUpload"
              >
                <el-button class="primary-btn" size="small" type="primary">
                  {{ $t("seek.upload") }}
                </el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
              <!-- <uploadFile
                :format="docFormat" 
                :limit="docLimit"
                :uploadStatus="docOk"
                @upPicGroupImg="uploadFile"
                /> -->
              <el-button
                class="primary-btn"
                @click="handleReply"
                size="small"
                type="primary"
                >{{ $t("seek.submit") }}</el-button
              >
            </div>
          </div>
        </div>
        <div
          class="record"
          v-else
          :style="seekInfo.recordList.length > 0 ? '' : 'border:none;'"
        >
          <div
            class="customer_service_box flex_only_center"
            v-for="(item, index) in seekInfo.recordList"
            :key="index"
          >
            <div class="customer_header flex_center">
              <div class="left off" v-if="item.replyType == 1">
                <i class="el-icon-service"></i>
              </div>
              <div class="left" v-if="item.replyType == 0">
                <div v-if="item.customerIcon == ''" class="cus">
                  <i class="el-icon-user-solid"></i>
                </div>
                <div v-else class="user_avatar">
                  <img :src="item.customerIcon" alt="" />
                </div>
              </div>
              <div class="right">
                <p class="offname" v-if="item.replyType == 1">
                  {{ $t("seek.official") }}
                </p>
                <p class="cusname" v-if="item.replyType == 0">
                  {{ item.customerName }}
                </p>
                <span :class="item.replyType == 0 ? 'cusname' : 'offname'">{{
                  item.createTime
                }}</span>
              </div>
            </div>
            <div :class="item.replyType == 1 ? 'offname' : 'cuscontent'">
              {{ item.replyContent }}
            </div>

            <div class="file">
              <div
                class="file-list"
                style="cursor: pointer"
                v-for="(data, idx) in item.fileList"
                :key="idx"
              >
                <div class="left">
                  <i class="el-icon-document"></i
                  ><span>{{ data.fileName }}</span>
                </div>
                <div class="right" @click="downLoad(data.filePath)">
                  {{ $t("home.down") }}
                </div>
              </div>
            </div>
            <!-- v-show="item.replyType==1" -->
            <div
              class="reply_btn flex-right"
              v-show="seekInfo.recordList.length > 0 && item.replyType == 1"
            >
              <el-button
                class="primary-btn"
                v-show="!replyCus && index + 1 == seekInfo.recordList.length"
                size="small"
                @click="handleReplyCus(item.qualityInquiryFormRecordId)"
                type="primary"
                >{{ $t("request.ask") }}</el-button
              >
            </div>

            <div
              class="reply_box"
              v-show="
                item.replyType == 1 &&
                replyCus &&
                currentRecordId == item.qualityInquiryFormRecordId
              "
            >
              <el-input
                type="textarea"
                :maxlength="2950"
                v-model="replyContent"
              ></el-input>
              <div class="btn flex" style="align-items: flex-start">
                <el-upload
                  class="upload-demo"
                  ref="uploadFile"
                  :action="action"
                  :headers="header"
                  multiple
                  :on-success="handleFileSuccess"
                  :before-upload="beforeFileUpload"
                >
                  <el-button class="primary-btn" size="small" type="primary">
                    {{ $t("seek.upload") }}
                  </el-button>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
                <!-- <uploadFile
                                :format="docFormat" 
                                :limit="docLimit"
                                :uploadStatus="docOk"
                                @upPicGroupImg="uploadFile"
                                /> -->
                <el-button
                  class="primary-btn"
                  @click="handleReply"
                  size="small"
                  type="primary"
                >
                  {{ $t("seek.submit") }}
                </el-button>
              </div>
            </div>
            <el-divider></el-divider>
          </div>
        </div>
      </el-form>
    </div>
    <div class="cancel" v-show="seekInfo.status == 0">
      <el-button class="primary-btn" type="primary" @click="handleCancelSeek">{{
        $t("seek.cancelSeek")
      }}</el-button>
    </div>
    <el-dialog :title="$t('seek.cancelSeek')" :visible.sync="dialogCancel" width="520px">
      <span>{{ $t("seek.isCancelSeek") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="primary-btn lang-but"
          type="primary"

          @click="handleCancel"
          >{{ $t("seek.confirm") }}</el-button
        >
        <el-button
          class="primary-btn "
          plain
          @click="dialogCancel = false"
          >{{ $t("climant.look") }}</el-button
        >
      </span>
    </el-dialog>
    <view-img-video ref="viewRef" :list="previewList"/>
  </div>
</template>
<script>
import mycheck from "@/components/mycheck";
import uploadFile from "@/components/uploadFile";
import { seekReply, seekReplyUpload, cancelSeek } from "@/api/seek";
import { getStorage, getSession } from "@/util/localStor";
import { uploadUrl } from "@/util/url";
import { readMsg } from "@/api/part";
import ViewImgVideo from "@/components/viewImgVideo.vue";

export default {
  components: {
    uploadFile,
    mycheck,
    ViewImgVideo,
  },
  data() {
    return {
      previewList:[],
      isRecord: true,
      fileList: [],
      seekInfo: {},
      header: {
        satoken: sessionStorage.getItem("satoken"),
      },
      
      action: uploadUrl + "/customer/quality/reply/upload",
      
      replyContent: "",
      replyCus: false,
      check: true,
      showAll: false,
      dialogCancel: false,
      currentRecordId: "",
    };
  },
  mounted() {
    this.seekInfo = getStorage("seekData");
    this.previewList = this.seekInfo.fileList?.filter(item=>{
      return 'image,video'.indexOf(item.fileType.slice(0,5)) !== -1
    })
    if (this.seekInfo.recordList) {
      this.seekInfo.recordList.length > 0
        ? (this.isRecord = true)
        : (this.isRecord = false);
    }
    if (this.$route.query && this.$route.query.unread > 0) {
      this.readDetail();
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async readDetail() {
      let query = {
        data: {
          dataId: this.seekInfo.qualityInquiryFormId,
          customerId: getSession("person").customerId,
          notificationType: 1,
        },
      };
      const res = await readMsg(query);
      this.$store.state.refresh = new Date().getTime();
    },
    beforeFileUpload(file) {
      let lang = "";
      let language = sessionStorage.getItem("lang");
      language == "zh"
        ? (lang = 0)
        : language == "en"
        ? (lang = 1)
        : language == "ru"
        ? (lang = 2)
        : (lang = 3);
      this.header.lang = lang;
    },
    // 下载
    downLoad(url, index) {
      if(index === 0 || index){
        this.$set(this.seekInfo.fileList[index], "downStatus", true);
      }
      window.open(url);
    },
    showViewBtn(type) {
      const fileExtension = type.slice(0,5) 
      return 'image,video'.indexOf(fileExtension) !== -1
    },
    // 预览
    viewFile(data) {
      this.$refs.viewRef.init(data);
    },
    handleReplyCus(id) {
      this.replyCus = true;
      this.currentRecordId = id;
    },
    handleCancelSeek() {
      this.dialogCancel = true;
      // this.$confirm('', this.$t('home.calcelClaimant'), {
      //   confirmButtonText: this.$t('seek.confirm'),
      //   cancelButtonText: this.$t('climant.look'),
      // }).then(() => {
      //   this.handleCancel()
      // })
    },
    async handleCancel() {
      let query = {
        data: {
          qualityInquiryFormId: this.seekInfo.qualityInquiryFormId,
          status: 3,
        },
      };
      const res = await cancelSeek(query);
      if (res.status == 0) {
        this.dialogCancel = false;
        this.$confirm("", this.$t("request.cancelOk"), {
          confirmButtonText: this.$t("home.iKonw"),
        }).then(() => {
          this.$router.go(-1);
        });
      }
    },
    getStatus(data) {
      let status;
      if (data == 0) status = this.$t("home.waitSl");
      if (data == 1) status = this.$t("home.slIng");
      if (data == 2) status = this.$t("home.closed");
      if (data == 3) status = this.$t("home.canceled");
      return status;
    },
    handleFileSuccess(res, file) {
      if (res.status == 0) {
        let data = res.data;
        let obj = {
          uploadFileId: data.uploadFileId,
          // dataId: data.dataId,
          uploaderId: data.uploaderId,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileType: data.fileType,
          filePath: data.filePath,
          fileSource: data.fileSource,
        };
        this.fileList.push(obj);
      } else {
        this.$DonMessage.warning(res.message);
        let uid = file.uid; // 关键作用代码，去除文件列表失败文件
        let idx = this.$refs.uploadFile.uploadFiles.findIndex(
          (item) => item.uid === uid
        );
        this.$refs.uploadFile.uploadFiles.splice(idx, 1);
      }
    },
    // 上传附件
    async uploadFile(file) {
      const res = await seekReplyUpload(file);
      if (res.status == 0) {
        let data = res.data;
        let obj = {
          uploadFileId: data.uploadFileId,
          // dataId: data.dataId,
          uploaderId: data.uploaderId,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileType: data.fileType,
          filePath: data.filePath,
          fileSource: data.fileSource,
        };
        this.fileList.push(obj);
        this.docOk = true;
      } else {
        this.$DonMessage.warning(res.message);
        this.docOk = false;
      }
    },
    async handleReply() {
      let query = {
        data: {
          qualityInquiryFormId: this.seekInfo.qualityInquiryFormId,
          replyContent: this.replyContent,
          fileList: [...this.fileList],
        },
      };
      // console.log(query)
      // return
      const res = await seekReply(query);
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("home.submitReplyOk"))
        this.$router.go(-1);
      } else {
        this.$DonMessage.warning(res.message);
      }
    },
  },
  timestampToTime(times) {
    let time = times[1];
    let mdy = times[0];
    mdy = mdy.split("/");
    let month = parseInt(mdy[0]);
    let day = parseInt(mdy[1]);
    let year = parseInt(mdy[2]);
    return year + "-" + month + "-" + day + " " + time;
  },
};
</script>
<style lang="scss" scoped>
.seek_detail_page {
  padding: 0 !important;
  // padding-left: 30px;
  margin-top: 15px;
  // padding-bottom: 20px;
  ::v-deep .el-input {
    // width: 250px;
  }
  .top-container {
    padding: 0 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    margin-bottom: 34px;
    .title-icon {
      margin-right: 10px;
    }
    .flex_between{
      display: flex !important;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .lookall {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
  .el-input__inner {
    width: 300px;
  }

  .status {
    font-size: 16px;
    color: #55ca7d;
    line-height: 20px;
    font-weight: bold;
  }
  .title {
    margin: 20px 0;
    p {
      text-shadow: rgb(189, 49, 36) 0px 2px 6px;
      font-size: 14px;
      line-height: 20px;
      color: #101010;
      font-weight: bold;
    }
    .dash {
      width: 90%;
      border-bottom: 1px dashed #5b6b73;
      margin-left: 20px;
    }
  }
  .seek_title {
    span {
      width: 100px;
    }
  }
  .word {
    padding-right: 30px;
    box-sizing: border-box;
    .no-records {
      padding: 0 30px;
      .el-textarea__inner {
        width: 80%;
        height: 100px;
      }
      .btn {
        width: 80%;
        margin-top: 20px;
        justify-content: space-between;
      }
    }
  }
  .record {
    margin: 30px;
    border: 1px solid #dcdfe6;
    border-radius: 10px;
    padding: 20px;

    .customer_header {
      margin-bottom: 20px;
      .left {
        margin-right: 10px;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        overflow: hidden;
        // background-color: #4095E5;
        text-align: center;
        i {
          color: #fff;
          font-size: 50px;
          line-height: 80px;
        }
      }
      .off {
        background-color: #4095e5;
      }
      .cus {
        background-color: #eee;
      }
      .offname {
        color: #4095e5;
      }
      .cusname {
        color: #5b6b73;
      }
      .cuscontent {
        color: #333;
        overflow: hidden;
        word-wrap: break-word;
      }
      .user_avatar {
        width: 80px;
        img {
          width: 100%;
          object-fit: cover;
        }
      }
      .right {
        color: #4095e5;
        p {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 20px;
        }
        span {
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
    .customer_service_box {
      margin-bottom: 15px;
    }
    .offname {
      color: #4095e5;
    }
    .cuscontent {
      color: #333;
      overflow: hidden;
      word-wrap: break-word;
    }

    .btn {
      width: 80%;
      margin-top: 20px;
      justify-content: space-between;
    }
  }
  .form-container {
    // margin-top: 34px;
    padding: 0 60px;
  }
}
.file {
  .down-icon {
    margin-left: 10px;
    color: #1890ff;
  }
  margin-top: 20px;
  // width: 100%;
  .file-list {
    // background: #eee;
    margin: 0 10px;
    padding: 0 5px;
    // width: 200px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    // justify-content: center;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
.reply_btn {
  margin-top: 15px;
}
.cancel {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
</style>
